import styled from 'styled-components';

export const SocialStyled = styled.div`
  display: flex;
`;

export const SocialIconBoxStyled = styled.a`
  margin-right: 16px;
`;
